import { memo } from 'react';

import ArrowLink from '../ArrowLink';
import classes from './preview-card.module.scss';

interface IPreviewCardProps {
  text: string;
  link: string;
  picture: string;
  division: string;
  order: number;
}

function PreviewCard({
  text,
  link,
  picture,
  division,
  order,
}: IPreviewCardProps) {
  return (
    <div className={classes.container} style={{ order }}>
      <img src={picture} alt="" className={classes.image} />
      <div className={classes.text}>{text}</div>
      <ArrowLink division={division} text="Подробнее" route={link} />
    </div>
  );
}

export default memo(PreviewCard);
